import classnames from "classnames";
import dayjs from "dayjs";
import { Typography } from "@mui/material";

import { LoadingModalWithTrigger } from "../heat/HeatModal";
import { LivePill } from "../heat/badges/LivePill";
import { T } from "../../util/t";
import { useHeatRowStyles } from "./heatRowStyles";
import { DivisionPill } from "../division/DivisionPill";

export const HeatRow = ({ heat, divisionIndicator }) => {
    const isLive = !!heat.startTime && !heat.endTime;
    const isFinished = !!heat.endTime;
    const classes = useHeatRowStyles();

    return (
        <LoadingModalWithTrigger heat={heat} linkVariant={isLive ? "label1" : "body1"}>
            <div className={classes.row}>
                <div className={classes.time}>{dayjs(heat.scheduledTime).format("HH:mm")}</div>

                <section className={classnames(classes.heat, { isFinished })}>
                    <DivisionPill indicator={divisionIndicator} className={classes.division}>{heat.eventDivision.division.name}</DivisionPill>

                    <div>
                        <T>{heat.round}</T>
                        &nbsp;:&nbsp;
                        {heat.config.runBased ?
                            <T number={heat.position + 1}>run_number</T> :
                            <T number={heat.position + 1}>heat_number</T>}
                    </div>
                </section>

                <aside className={classes.duration}>
                    {isLive ?
                        <LivePill heat={heat} className={classes.livePill}/> :
                        !isFinished &&
                        <Typography variant="caption" color="textSecondary"><T duration={heat.heatDurationMinutes}>heat_duration</T></Typography>
                    }
                </aside>
            </div>
        </LoadingModalWithTrigger>
    );
};
